import { AppClient as RawAppClient } from './appclient.js';

export const AppClient = RawAppClient as {
  LOCAL_MAIN: string;
  LOCAL_LITE: string;
  QA_MAIN: string;
  QA_LITE: string;
  PREPROD_MAIN: string;
  PREPROD_LITE: string;
  PROD_MAIN: string;
  PROD_LITE: string;
  URL_LOCAL_MAIN: string;
  URL_LOCAL_LITE: string;
  URL_QA_MAIN: string;
  URL_QA_LITE: string;
  URL_PREPROD_MAIN: string;
  URL_PREPROD_LITE: string;
  URL_PROD_MAIN: string;
  URL_PROD_LITE: string;
  OPENOFFICE_URL_QA:string
};
